import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import DocumentTitle from 'react-document-title'
import PlacesList from './PlacesList'

const placesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Places',
    path: '/places',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const PlacesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Places'}></DocumentTitle>
              <PageTitle breadcrumbs={placesBreadcrumbs}>Lists</PageTitle>
              <PlacesList />
            </>
          }
        />
        <Route index element={<Navigate to='/places/list' />} />
      </Route>
    </Routes>
  )
}

export default PlacesPage
